var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injector, ElementRef, OnInit, AfterViewInit } from '@angular/core';
import { ThemesLayoutBaseComponent } from '@app/shared/layout/themes/themes-layout-base.component';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { LayoutRefService } from '@metronic/app/core/_base/layout/services/layout-ref.service';
import { AppConsts } from '@shared/AppConsts';
var Theme2LayoutComponent = /** @class */ (function (_super) {
    __extends(Theme2LayoutComponent, _super);
    function Theme2LayoutComponent(injector, layoutRefService, document) {
        var _this = _super.call(this, injector) || this;
        _this.layoutRefService = layoutRefService;
        _this.document = document;
        _this.remoteServiceBaseUrl = AppConsts.remoteServiceBaseUrl;
        return _this;
    }
    Theme2LayoutComponent.prototype.ngOnInit = function () {
        this.installationMode = UrlHelper.isInstallUrl(location.href);
    };
    Theme2LayoutComponent.prototype.ngAfterViewInit = function () {
        this.layoutRefService.addElement('header', this.ktHeader.nativeElement);
    };
    Theme2LayoutComponent.prototype.toggleLeftAside = function () {
        this.document.body.classList.toggle('kt-header-menu-wrapper--on');
        this.document.getElementById('kt_header_menu_wrapper').classList.toggle('kt-header-menu-wrapper--on');
    };
    return Theme2LayoutComponent;
}(ThemesLayoutBaseComponent));
export { Theme2LayoutComponent };
